import type { HttpError } from '@refinedev/core'
import { Spin } from 'antd'

import { isNotFound } from '@/hooks/useAdminRecord'

const FALLBACK_STYLE = { textAlign: 'center', padding: 48 } as const

export function RecordFallback({
  label,
  isLoading,
  error,
}: {
  label: string
  isLoading: boolean
  error: HttpError | null
}) {
  if (isLoading) {
    return (
      <div style={FALLBACK_STYLE}>
        <Spin size="large" />
      </div>
    )
  }
  if (error && !isNotFound(error)) {
    return (
      <div style={FALLBACK_STYLE}>
        Failed to load {label}: {error.message}
      </div>
    )
  }
  return <div style={FALLBACK_STYLE}>{label} not found</div>
}
